import { render, staticRenderFns } from "./CategoriesList.vue?vue&type=template&id=716960e4&scoped=true&"
import script from "./CategoriesList.vue?vue&type=script&lang=js&"
export * from "./CategoriesList.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesList.vue?vue&type=style&index=0&id=716960e4&prod&lang=scss&scoped=true&"
import style1 from "./CategoriesList.vue?vue&type=style&index=1&id=716960e4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716960e4",
  null
  
)

export default component.exports